function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.875,6.375H4.125a.375.375,0,0,0,0,.75h3.75a.375.375,0,0,0,0-.75Zm.75-2.25H3.375a.375.375,0,1,0,0,.75h5.25a.375.375,0,0,0,0-.75ZM6,0C2.687,0,0,2.35,0,5.25A5.025,5.025,0,0,0,2.25,9.345V12l2.628-1.595A6.881,6.881,0,0,0,6,10.5c3.314,0,6-2.35,6-5.25S9.314,0,6,0ZM6,9.75a6.068,6.068,0,0,1-1.268-.138L2.967,10.674l.024-1.739A4.348,4.348,0,0,1,.75,5.25C.75,2.765,3.1.75,6,.75s5.25,2.015,5.25,4.5S8.9,9.75,6,9.75Z"
});

function SvgCommentWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24.00003,
    viewBox: "-1 -1 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentWhite);
export default __webpack_public_path__ + "static/media/comment-white.5527e1ed.svg";
export { ForwardRef as ReactComponent };